export const cTipoKardex = {
    entrada: 5500,
    salida: 5501,
    actualizacion: 5502
};
